import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumPriceListLineSortBy implements BaseEnumType {
  private static allValues: EnumPriceListLineSortBy[] = []; // make sure this is top-most
  
  public static nameAsc = new EnumPriceListLineSortBy(0, "NameAsc", "enum_price_list_line_sort_by_name_asc");
  public static nameDesc = new EnumPriceListLineSortBy(1, "NameDesc", "enum_price_list_line_sort_by_name_desc");
  public static abvAsc = new EnumPriceListLineSortBy(3, "AbvAsc", "enum_price_list_line_sort_by_abv_asc");
  public static abvDesc = new EnumPriceListLineSortBy(4, "AbvDesc", "enum_price_list_line_sort_by_abv_desc");
  public static priceAsc = new EnumPriceListLineSortBy(5, "PriceAsc", "enum_price_list_line_sort_by_price_asc");
  public static priceDesc = new EnumPriceListLineSortBy(6, "PriceDesc", "enum_price_list_line_sort_by_price_desc");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumPriceListLineSortBy.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNameAsc() { return this === EnumPriceListLineSortBy.nameAsc; }
  public isNameDesc() { return this === EnumPriceListLineSortBy.nameDesc; }
  public isAbvAsc() { return this === EnumPriceListLineSortBy.abvAsc; }
  public isAbvDesc() { return this === EnumPriceListLineSortBy.abvDesc; }
  public isPriceAsc() { return this === EnumPriceListLineSortBy.priceAsc; }
  public isPriceDesc() { return this === EnumPriceListLineSortBy.priceDesc; }

  public static getValues(): readonly EnumPriceListLineSortBy[] {
    return EnumPriceListLineSortBy.allValues;
  }

  public static getValuesExcept0(): readonly EnumPriceListLineSortBy[] {
    return EnumPriceListLineSortBy.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumPriceListLineSortBy {
    const found = EnumPriceListLineSortBy.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumPriceListLineSortBy - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumPriceListLineSortBy): EnumPriceListLineSortBy {
    const found = name ? EnumPriceListLineSortBy.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumPriceListLineSortBy - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumPriceListLineSortBy>): boolean {
    return this.key === other?.key;
  }
}